import Payment from 'payment';

function clearNumber(value = '') {
  return value.replace(/\D+/g, '');
}

export function getIssuerByCardNumber(card) {
  const issuer = Payment.fns.cardType(card);
  const cardsMap = {
    amex: 'AX',
    visa: ['VI', 'CB'],
    mastercard: ['CA', 'CB'],
    dinersclub: 'DC',
    unionpay: 'CU',
    maestro: 'MK',
    jcb: 'JC',
  }
  return cardsMap[issuer]
}

let prevDate = 0;
export function formatExpirationDate(value) {
  const clearValue = clearNumber(value);

  prevDate = clearValue[0] > 1 ? `0${clearValue}` : clearValue;

  if (prevDate.length >= 3) {
    return `${prevDate.slice(0, 2)}/${prevDate.slice(2, 4)}`;
  }

  return prevDate;
}

export function formatFormData(data) {
  return Object.keys(data).map((d) => `${d}: ${data[d]}`);
}
